import { checkPermission, Permission } from './permissions.ts';

/**
 * Metric IDs whose values are dollars: Admin-tier (VIEW_SPEND_METRICS), like
 * the dashboard's Spend and Revenue tabs. The one list the REST API and the
 * MCP server import (MET-3600); both gate history, definitions and dashboard
 * values with `canViewMetric`, so a new dollar metric added here is gated
 * everywhere.
 */

/** Company-wide monthly revenue from Epicor (MET-3527). */
export const EPICOR_REVENUE_METRIC_ID = 'epicor_revenue_monthly';

/** Monthly revenue attributed to customers through the Epicor customer map (MET-3532). */
export const EPICOR_CUSTOMER_REVENUE_METRIC_ID = 'epicor_customer_revenue_monthly';

/** Company revenue metrics (MET-3599). */
export const REVENUE_METRIC_IDS: ReadonlySet<string> = new Set([
  EPICOR_REVENUE_METRIC_ID,
  EPICOR_CUSTOMER_REVENUE_METRIC_ID,
]);

/** Infrastructure spend metrics in USD (the Spend tab and its stored components). */
export const SPEND_METRIC_IDS: ReadonlySet<string> = new Set([
  'azure_infra_spend_daily',
  'aws_infra_spend_daily',
  'aws_plus_account_spend_daily',
  'timescale_spend_daily',
]);

/** Every dollar metric: Admin-tier, served only to callers with VIEW_SPEND_METRICS. */
export const DOLLAR_METRIC_IDS: ReadonlySet<string> = new Set([
  ...SPEND_METRIC_IDS,
  ...REVENUE_METRIC_IDS,
]);

/**
 * Whether the caller may see a metric's values. Non-dollar metrics need only
 * VIEW_METRICS, which the caller is assumed to have already passed.
 */
export function canViewMetric(userGroups: string[], metricId: string): boolean {
  return !DOLLAR_METRIC_IDS.has(metricId) ||
    checkPermission(userGroups, Permission.VIEW_SPEND_METRICS);
}
